/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react';

import Grid from '@mui/material/Grid';
import { useStyles } from './styles';
import Tile from './tile';
import useWidgetTheme from '../../commons/widgetTheme';
import useUIStates from '../../store/models/uistates/useUIStates';
import useCommonStores from '../../store/useCommonStores';
function CalendarsList (props) {
    const {
        calendars = [],
        onCalendarSelect = () => {},
        isPreview = false,
    } = props;

    const {
        appStore,
    } = useCommonStores();

    const {
        widget,
        widgetTheme,
    }  = useWidgetTheme();

    const {
        selectCalendar,
    } = useUIStates();

    const classes = useStyles({
        widget,
        widgetTheme,
    });

    function fireGaEventForNewOutlookCalendar (data) {
        if(!isEmpty(data) && data.value === 'outlook-new') {
            appStore.gaNewOutlookCalendar();
        }
    }

    function renderCalendars () {    
        return calendars.map((data, index) =>{
            return (<Tile
                key={`calendar-${index}`}
                data={data}
                widget={widget}
                widgetTheme={widgetTheme}
                onClick={(data) => {
                    if (isPreview) return;
                    onCalendarSelect();
                    selectCalendar(data.value);
                    appStore.gaChooseCalendar();
                    fireGaEventForNewOutlookCalendar(data);
                }}
            />);
        });
    }

    return (
        <React.Fragment>
            <Grid
                id="content"
                className={classes.list}
            >
                <Grid
                    className={classes.listContent}
                >
                    { renderCalendars() }
                </Grid>
            </Grid>           
        </React.Fragment>
    );
}

CalendarsList.propTypes = {
    calendars: PropTypes.array,
    onCalendarSelect: PropTypes.func,
    isPreview: PropTypes.bool,
};

export default observer(CalendarsList);